module.exports = __webpack_public_path__ + "static/media/mountain.ec15cce5.jpeg";